import { Popup } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { memo, useCallback } from 'react';

import { Content } from './components';
import { netSuiteSourceMatchingLineState, netSuiteTargetMatchingLineState } from './NetSuiteMatchingPopup.states';
import { NetSuiteMatchingPopupProps } from './NetSuiteMatchingPopup.types';

export const NetSuiteMatchingPopup = memo((props: NetSuiteMatchingPopupProps) => {
    const sourceLine = useAtomValue(netSuiteSourceMatchingLineState);
    const resetSourceLine = useResetAtom(netSuiteSourceMatchingLineState);
    const resetTargetLine = useResetAtom(netSuiteTargetMatchingLineState);

    const onPopupClose = useCallback(() => {
        resetSourceLine();
        resetTargetLine();
    }, [resetSourceLine, resetTargetLine]);

    return (
        <Popup open={Boolean(sourceLine)} onClose={onPopupClose} preventAutoClose fullScreen>
            <Content {...props} onClose={onPopupClose} />
        </Popup>
    );
});

NetSuiteMatchingPopup.displayName = 'NetSuiteMatchingPopup';
